import TopMenu from '../../shared/TopMenu/TopMenu';
import ProductMenu from '../ProductMenu/ProductMenu';
import Visualizer from '../Visualizer/Visualizer';
import StartPage from '../StartPage/StartPage';

import styles from './VisualizerPage.module.css';

export default function VisualizerPage() {

    return (
        <>
            <StartPage />
            <TopMenu extended={true} />
            
            <section className={styles.visualizerView}>
                <div className={styles.content}>
                    <div className={styles.patternDiv}>
                        <Visualizer />
                    </div>
                    <div className={styles.productsDiv}>
                        <ProductMenu />
                    </div>
                </div>
            </section>

        </>
        
    );
}

